module.exports = __webpack_public_path__ + "img/heavy-hauler.07a47834.svg";